import React, { useEffect, useState } from 'react';
import './HighscoreMini.scss';
import { useGetHighscoreFilterItems, useGetHighscoresForUser } from './Hooks/useQuiz';
import { HighscoreFilterType } from './quiztypes';
import BizCarousel from '../../../Js/React/UI/BizCarousel/BizCarousel';
import { BizNumberFormat } from '../../../Js/React/UI/BizFormat';
import BizPhrase from '../../Components/Phrase';
import { goto } from '../../../Js/React/Services/legacy';

const HighscoreMini = () => {
	const [anyLoaded, setAnyLoaded] = useState(false);
	const filterTypes = useGetHighscoreFilterItems();

	const setListLoaded = () => {
		if (!anyLoaded) {
			setAnyLoaded(true);
		}
	};

	const clickHandler = () => {
		goto('base.modules.speedquiz');
	};

	return (
		<div className={`quiz-highscore-mini-wrapper ${anyLoaded ? 'loaded' : ''}`} onClick={clickHandler}>
			{filterTypes !== undefined && (
				<BizCarousel settings={{ arrows: false, autoplay: true }}>
					{filterTypes?.map((ft, index) => (
						<HighscoreMiniPanel key={index} filter={ft} setListLoaded={setListLoaded} />
					))}
				</BizCarousel>
			)}
		</div>
	);
};

type HighscoreMiniPanelProps = {
	filter: HighscoreFilterType;
	setListLoaded: () => void;
};

const HighscoreMiniPanel = ({ filter, setListLoaded }: HighscoreMiniPanelProps) => {
	const { highscores } = useGetHighscoresForUser(filter, 3, true);

	useEffect(() => {
		if (highscores && highscores.length > 0) {
			setListLoaded();
		}
	}, [highscores]);

	if (!highscores || highscores.length < 1) return null;

	const hs = highscores[0];
	const hasData = hs.ScoreItems.length > 0;

	return (
		<div className='quiz-highscore-mini-slide'>
			<ul>
				<li>
					<BizPhrase phraseKey='SPEEDQUIZ.HIGHSCOREMINI.HEADER'></BizPhrase>: {filter.UserUnitName}
				</li>
				{hasData &&
					hs.ScoreItems.map((si, index) => (
						<li key={index}>
							<span className='rank biz-secondary'>{index + 1}</span>
							<span>{si.Alias}</span>
							<span>
								<BizNumberFormat value={si.Score} format='THOUSAND_DELIMITED' /> p
							</span>
						</li>
					))}
				{!hasData && <BizPhrase phraseKey='SPEEDQUIZ.HIGHSCORELIST.NO_RESULTS'></BizPhrase>}
			</ul>
		</div>
	);
};

export default HighscoreMini;
